import React from "react";
import {ProjectEntity} from "../../../api/entities";
import ProjectsTableRow, {ProjectsTableRowProps} from "./ProjectsTableRow";


type Props = {
    projects: Array<ProjectEntity>;
} & Omit<ProjectsTableRowProps, 'project'>

const ProjectsTable: React.FC<Props> = ({projects, ...rest}) => {

    return (
        <tbody>
        {
            projects.map(project => {
                return (
                    <ProjectsTableRow key={project.id} project={project} {...rest} />
                );
            })
        }
        </tbody>
    );
};

export default ProjectsTable;
